"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReadOnly = isReadOnly;
exports.isTextarea = isTextarea;
exports.isSingleLineText = isSingleLineText;
exports.isDate = isDate;
exports.isCurrency = isCurrency;
exports.isFormattedNumber = isFormattedNumber;
exports.isNumber = isNumber;
exports.isEnum = isEnum;
exports.isMultienum = isMultienum;
exports.isMultiple = isMultiple;
exports.isPercent = isPercent;

var PropertyFieldTypes = _interopRequireWildcard(require("customer-data-objects/property/PropertyFieldTypes"));

var PropertyTypes = _interopRequireWildcard(require("customer-data-objects/property/PropertyTypes"));

function isReadOnly(property) {
  return property.readOnlyValue || property.calculated || property.name === 'associatedcompanyid' || property.name === 'file_upload_';
}

function isTextarea(property) {
  return property && [PropertyTypes.STRING, 'multiline'].includes(property.type) && (property.fieldType === PropertyFieldTypes.TEXTAREA || property.name === 'description');
}

function isSingleLineText(property) {
  return property && property.type === PropertyTypes.STRING && !isTextarea(property) && !['firstname', 'lastname', 'phone'].includes(property.name);
}

function isDate(property) {
  return property && [PropertyTypes.DATE_TIME, PropertyTypes.DATE].includes(property.type);
}

function isCurrency(property) {
  return property && property.showCurrencySymbol && property.type === PropertyTypes.NUMBER;
}

function isFormattedNumber(property) {
  return property && property.type === PropertyTypes.NUMBER && property.numberDisplayHint !== 'unformatted';
}

function isNumber(property) {
  return property && [PropertyTypes.NUMBER, 'integer'].includes(property.type);
}

function isEnum(property) {
  return property && [PropertyTypes.ENUMERATION, 'multienum'].includes(property.type);
}

function isMultienum(property) {
  return property && property.fieldType === PropertyFieldTypes.CHECKBOX && property.type !== PropertyTypes.BOOL;
}

function isMultiple(property) {
  return property && (property.type === PropertyTypes.STRING || isMultienum(property));
}

function isPercent(property) {
  return property && property.name === 'hs_predictivecontactscore_v2';
}